"use strict";

import React, {useCallback, useEffect, useState} from 'react';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';
import Icon from "../../component/Icon";
import formInputErrorClassName from "../../formInputErrorClassName";
import scrollTo from 'scroll-to';

const AccountEchecksCreateTermsOfServiceForm = ({
        stepsHeaderOffsetTop= 0,
        formData={},
        onSubmit=()=>{},
    }) => {
    const [hasReadTermsOfService, setHasReadTermsOfService] = useState(false);
    const handleTermsOfServiceOnBottom = useCallback(() => {
        setHasReadTermsOfService(()=>{
            return true;
        });
    }, [setHasReadTermsOfService]);
    const termsOfServiceRef = useBottomScrollListener(handleTermsOfServiceOnBottom);

    useEffect(()=>{
        scrollTo( 0, (stepsHeaderOffsetTop || 0) );
    }, []);

    function handleSubmit(e){
        e.preventDefault();
        onSubmit({
            agree_to_tos: true,
            scrolledToBottomOfTerms: hasReadTermsOfService,
        });
    }

    function formInputClassName(name = '') {
        return formInputErrorClassName(name, errors);
    }

    return (
        <form id="authorization-create" name="authorization-create" className="is-marginless"
              onSubmit={handleSubmit}>
            <fieldset>
                <legend>Terms Of Service:</legend>
                <ol className="form__input-list">
                    <li className="form__input-list-item">
                        <div ref={termsOfServiceRef}
                            className="content__window content__window--short">
                            <p>I authorize Tangible Values, Inc. and its designated Financial Agent to initiate ACH
                                Electronic Funds Withdrawal entry to the financial institution account indicated
                                on this web form for payments indicated on my Tangible Values, Inc. orders. I also
                                authorize the Financial institution to debit the entry to this account. I
                                understand that this authorization will remain in effect until I notify Tangible Values,
                                Inc. using the online Tangible Values e-check notification system that I wish to cancel
                                this ACH authorization.</p>
                            <p>I agree to notify Tangible Values, Inc. with an on-line Tangible Values e-check form of any changes
                                in my account information or termination of this authorization at least 15 days
                                prior to the scheduled billing date. If a payment is scheduled to be made on a
                                weekend or holiday, I understand the payment may be made on the next business
                                day. </p>
                            <p>Authorized payments may be made as soon as I approve and submit my order for
                                products and services from Tangible Values, Inc. I understand normal ACH Tangible Values e-check
                                payments may be made using my approved bank account after the order date, but
                                usually within 2 to 4 business days. </p>
                            <p>In the case of an ACH Transaction being rejected for Non-Sufficient Funds (NSF)
                                or any other reason, I understand that Tangible Values, Inc. may at its discretion
                                attempt to process the charge again within 30 days, and I agree to an additional
                                charge (currently up to $25) for each attempt returned ACH item will be
                                initiated as a separate transaction from the authorized payment(s). </p>
                            <p>I acknowledge that the origination of ACH transactions to my account must comply
                                with the appropriate provisions of U.S. law. I agree to be bound by NACHA rules
                                and operating guidelines. I will not dispute the company's recurring billing
                                with my bank so long as the transaction corresponds to the terms indicated in
                                this agreement.</p>
                            <p>I understand that the limit of liability to Tangible Values, Inc. regarding the use of
                                Tangible Values e-check ACH Electronic Funds Withdrawal and my authorized financial
                                account in all cases is limited to my Tangible Values, Inc. order total that uses the
                                Tangible Values e-check system.</p>
                        </div>
                    </li>
                </ol>
            </fieldset>
            <fieldset>
                <div className="text__center">
                    <button type="submit"
                       name="agree_to_tos"
                       className={`btn__primary no-wrap`} >
                        I agree to all terms of service above <Icon name="right" className="icon--collapse-right" />
                    </button>
                </div>
            </fieldset>
        </form>
    );
};

export default AccountEchecksCreateTermsOfServiceForm;
